import React from 'react';

import { TranslatedLinkMessage } from './TranslatedLinkMessage';

const WarrantySupportText = () => (
  <p className="age-gate__warranty-support-text">
    <TranslatedLinkMessage
      id={'WARRANTY_SUPPORT_TEXT'}
      link={'WARRANTY_SUPPORT_URL'}
      linkText={'WARRANTY_SUPPORT_LINK_TEXT'}
    />
  </p>
);

export default WarrantySupportText;
